(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const STYLE_ID = 'tmfl-shopify-forms-shadow-style';

    function injectStylesIntoShopifyForms() {
      document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
        const shadow = embed.shadowRoot;
        if (!shadow) return; 

        if (shadow.getElementById(STYLE_ID)) return;

        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = `
          button[type="submit"] {
            border-radius: 30px !important;
            text-transform: uppercase !important;
          }
        input {
        border-radius: 30px !important;}
        `;
        shadow.appendChild(style);
      });
    }

    injectStylesIntoShopifyForms();

    const observer = new MutationObserver(() => {
      injectStylesIntoShopifyForms();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
})();
